import React from 'react';
import { observer } from 'mobx-react';

import { modalStore } from 'apps/modals/app';

import { Button, Checkbox } from 'components';
import { useAppManager } from 'core/hooks';
import { TableSection } from 'apps/productQuote/ProductQuoteTables/TableSection';

import { columns } from 'apps/rfq/rfqList/connManager';
import { useAsModal } from 'hooks';
import SelectRFQAppManager from './appManager';

const getCellComp = (manager: SelectRFQAppManager) =>
  observer(({ data }: { data: any }) => {
    const handleChange = () => {
      manager.ToggleRFQ(data.id);
    };
    const isSelected = manager.selectedRFQIds.includes(data.id);
    return (
      <Checkbox
        id={data.id}
        value={data.id}
        onChange={handleChange}
        checked={isSelected}
      />
    );
  });

function getCheckBoxColumn(manager: SelectRFQAppManager) {
  return {
    Header: '',
    accessor: '',
    component: true,
    Cell: getCellComp(manager),
  };
}

interface EditPartsModalProps {
  fadeIn: () => void;
  customerSpaceId?: string;
  selectedRFQIds: string[];
  navigateShipmentQuoteToIds: (ids: string[]) => void;
}

export const EditPartsModal = observer(function EditPartsModal({
  fadeIn,
  customerSpaceId,
  selectedRFQIds,
  navigateShipmentQuoteToIds,
}: EditPartsModalProps) {
  useAsModal(fadeIn, 150);

  const manager = useAppManager(SelectRFQAppManager, null, {
    customerSpaceId,
    selectedRFQIds,
    navigateShipmentQuoteToIds,
  });

  const handleClose = () => {
    modalStore.Close();
  };

  const finalColumns = [
    getCheckBoxColumn(manager),
    ...columns.slice(0, columns.length - 1),
  ];

  return (
    <TableSection
      loading={!!manager.rfqsQuery?.loading}
      columns={finalColumns}
      nodes={manager.rfqModels}
      title='Customer RFQs'
      emptyTablePlaceholder={false}
      Button={
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button text='Close' onClick={handleClose} />
        </div>
      }
    />
  );
});
